<template>
  <div>
    <!-- header -->
    <HeadBar @nameClick = "nameClick"></HeadBar>
    <div class="conent-box">
      <div class="change-year">
        <el-date-picker
          v-model="year"
          type="year"
          placeholder="选择年份" format="yyyy 年" @change="changeYear">
        </el-date-picker>
      </div>
      <!--表格-->
      <kt-table :data="pageResult" :columns="columns" :isInitialize="isInitialize" :showOperation="showOperation" :showPrintBtn="showPrintBtn"
                :showBatchDelete = "showBatchDelete" @findPage="findPage" @handleDelete="handleDelete" @handlePrint="handlePrint"></kt-table>
    </div>

    <!--打印-->
    <div class="print-box">
      <div v-for="(item,index) in printData" :key="index" :id="'printDiv'+ index" style="page-break-after:always">
        <div class="print-content">
          <div class="print-content-con center-x">
            <p v-for="(item1,indexp) in item.salaryOrderHeadValues" :key="indexp"
               v-if="item1.headTitleNm!='姓名'&&item1.headTitleNm!='名字'&&item1.headTitleNm!='身份证号码'&&item1.headTitleNm!='身份证号'&&item1.headTitleNm!='证件号码'&&item1.headTitleNm!='证件号'&&item1.headTitleNm!='序号'"
            >{{item1.headTitleNm}}：{{item1.headValue}}</p>
            <p v-if="item.salaryOrderHeadValues.length%2!=0"></p>
          </div>
        </div>
        <div class="print-bottom">
          <div class="print-bottom-con center">
            <p style="width:98%;">公司名称：{{item.salaryOrderMain.companyNm}}</p>
            <p style="width:98%;">工资月份：{{item.salaryOrderMain.salaryYear}}-{{item.salaryOrderMain.salaryMonth}}</p>
            <p v-for="(item2,index2) in item.salaryOrderHeadValues" :key="index2" v-if="item2.headTitleNm=='姓名' || item2.headTitleNm=='名字'">{{item2.headTitleNm}}：{{item2.headValue}}</p>
            <p v-for="(item2,index2) in item.salaryOrderHeadValues" :key="index2" v-if="item2.headTitleNm=='身份证号码' || item2.headTitleNm=='身份证号' || item2.headTitleNm=='证件号码' || item2.headTitleNm=='证件号'">{{item2.headTitleNm}}：{{item2.headValue}}</p>
            <p></p>
            <p class="print-bottom-index"><b>{{index+1}}</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import HeadBar from '@/components/HeadBar';
  import KtTable from "@/components/KtTable"
  import { format } from "@/utils/datetime"
  import Cookies from 'js-cookie'
  export default {
    components:{
      HeadBar,
      KtTable
    },
    name: 'Send',
    data() {
      return {
        showOperation:true, // 显示操作按钮
        showPrintBtn:true, //显示打印操作按钮
        showBatchDelete:false, //不显示分页
        isInitialize:false,  //默认不初始化，不自动加载findPage方法
        columns: [
          {prop:'index', label: '序号', minWidth: 100, type: 'index'},
          {prop:"salaryMonth", label:"所属月份", minWidth:100},
          {prop:"salaryTypeNm", label:"薪资类型", minWidth:100},
          {prop:"salaryCnt", label:"发送条数", minWidth:80},
          {prop:"publishDt", label:"发送时间", formatter:this.dateFormat,minWidth:100},
        ],
        pageRequest:{
          companyId: "",
          disablePaging: true,
          orderYear: new Date().getFullYear(),
        },
        pageResult:[],
        year:format(new Date()),
        companyOneId:'',
        thirdParty:sessionStorage.getItem('thirdParty'),// 判断是否是从第三方进来的
        printData:[], //打印数据
      };
    },
    watch:{
        printData:function(){
            this.$nextTick(function(){
                // 开始打印
                const promiseAll = [];
                const newWin = window.open("");
                for (let i = 0;i<this.printData.length;i++){
                    const imgToPrint = window.document.getElementById('printDiv' + i);
                    newWin.document.write(imgToPrint.outerHTML);
                }
                const styleSheet = '<style>@page{margin:0;}p{display:inline-block;width:49%;font-size:14px;line-height:28px;margin:0;}.print-content,.print-bottom{width:100%;height:69%;position:relative}' +
                    '.print-bottom{height:31%}.print-content-con,.print-bottom-con{position:absolute;width:72%;}.print-content-con{top:10%} .print-bottom p{font-size:16px;line-height:42px;}' +
                    '.center{top: 50%;left: 50%;-ms-transform: translateX(-50%) translateY(-50%);-moz-transform: translateX(-50%) translateY(-50%);-webkit-transform: translateX(-50%) translateY(-50%);transform: translateX(-50%) translateY(-50%);}' +
                    '.center-x {left: 50%;-ms-transform: translateX(-50%);-moz-transform: translateX(-50%);-webkit-transform: translateX(-50%);transform: translateX(-50%);}' +
                    '.print-bottom-index{font-size:32px;width:96%;text-align:right;}</style>';
                newWin.document.head.innerHTML = styleSheet;
                newWin.document.close();
                newWin.focus();
                // 判断全部图片是否加载成功
                Promise.all(promiseAll).then(img =>{
                    newWin.print();
                    newWin.close();
                }).catch(err=>{
                    newWin.close();
                })
            })
        }
    },
    methods: {
      nameClick:function (data) {
        sessionStorage.setItem('companyChange',JSON.stringify(data));
      },
      // 获取分页数据
      findPage: function (data) {
        var that = this;
        this.pageRequest.companyId = that.companyOneId.id;
        console.log(this.pageRequest);
        this.$api.send.getOrderList(this.pageRequest).then((res) => {
            if(res.status){
                this.pageResult = res.data;
            }else{
                this.$message({message: '操作失败, ' + res.msg, type: 'error'})
            }
        }).then(data!=null?data.callback:'')
      },
      // 删除
      handleDelete: function (data) {
        let formData = new FormData();//通过form数据格式来传
        formData.append("salaryOrderId", data.params[0].id);
        this.$api.send.del(formData).then(data!=null?data.callback:'')
      },
      // 选择年份时
      changeYear:function(){
        if(this.year){
          this.pageRequest.orderYear = this.year.getFullYear();
        }
        this.findPage(null);
      },
      // 时间格式化
      dateFormat: function (row, column, cellValue, index){
        return format(row[column.property])
      },
      // 打印
      handlePrint:function(data){
          this.$api.send.print({salaryOrderId:data.row.id}).then((res) => {
            this.printData = res.data;
          }).then(data!=null?data.callback:'')
      }
    },
    mounted() {
          var that = this;
          window.addEventListener('setItemEvent',function(e){
              if(e.key == "companyChange"){
                  that.companyOneId = JSON.parse(e.newVal);
                  that.findPage(null);
              }else if(e.key == "companyOneId"){
                  that.companyOneId = JSON.parse(e.newVal);
                  that.findPage(null);
              }
          });
      },
  };
</script>

<style scoped>
  .change-year{
    text-align: left;
    margin-bottom:20px;
  }
  /*打印*/
  .print-box,.print-box > div{
    height:100%;
    display:none;
  }
  .print-content,.print-bottom{
    width:100%;
    height:69%;
    position:relative;
  }
  .print-content-con,.print-bottom-con{
    position:absolute;
    width:72%;
  }
  .print-content-con{
    top:10%;
  }
  .print-content p,.print-bottom p{
    display:inline-block;
    width:49%;
    font-size:14px;
    line-height:28px;
    color:#333;
    text-align:left;
    margin: 0;
  }
  .print-bottom{
    height:31%;
  }
  .print-bottom p{
    font-size:16px;
    line-height:42px;
  }
  .print-bottom .print-bottom-index{
    width:96%;
    text-align:right;
    font-size:32px;
  }
  .center {
    top: 50%;
    left: 50%;
    -ms-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -webkit-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
  }
  .center-x {
    left: 50%;
    -ms-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
  }
</style>



// WEBPACK FOOTER //
// src/views/Send.vue